import EditIcon from '@mui/icons-material/Edit';
import { Box, Grid, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { AddToCalendarButton } from 'add-to-calendar-button-react';
import moment from 'moment';
import { EstateTaskInstance, EstateTaskInstanceStatus, FeatureSubscriptionType } from 'queries';

import { canIntegrateWithCalendar } from 'utils/feature-checker';

interface LabelCellProps extends GridRenderCellParams {
  estateSearchTaskInstances: EstateTaskInstance[];
  groupedEstateTaskInstancesAsArray: EstateTaskInstance[];
  featureSubscriptionType: FeatureSubscriptionType;
  classes: Record<string, string>;
  handleAddDeadlineClick: (e: React.MouseEvent) => void;
  setCurrentEstateTaskInstance: (instance: EstateTaskInstance) => void;
}

export const LabelCell = ({
  row,
  estateSearchTaskInstances,
  groupedEstateTaskInstancesAsArray,
  featureSubscriptionType,
  classes,
  handleAddDeadlineClick,
  setCurrentEstateTaskInstance,
}: LabelCellProps) => {
  const estateTaskInstance = row as EstateTaskInstance;
  const clientEstateTaskInstance =
    estateSearchTaskInstances.find((instance) => instance.id === estateTaskInstance.id) ||
    groupedEstateTaskInstancesAsArray.find((instance) => instance.id === estateTaskInstance.id)!;

  const hasCalendarFeature = canIntegrateWithCalendar(featureSubscriptionType);

  return (
    <Box className={classes.labelContainer}>
      <Typography
        className={
          clientEstateTaskInstance.status === EstateTaskInstanceStatus.Completed
            ? classes.estateTaskRowLabelCompleted
            : classes.estateTaskRowLabelNotCompleted
        }
        variant="body1"
        dangerouslySetInnerHTML={{
          __html: clientEstateTaskInstance.labelContext
            ? `<span>${clientEstateTaskInstance.label} <strong>(${clientEstateTaskInstance.labelContext})</strong></span>`
            : `<span>${clientEstateTaskInstance.label}</span>`,
        }}
      />
      <Typography
        className={
          !clientEstateTaskInstance.labelHint
            ? classes.estateTaskRowNoLabelHint
            : classes.estateTaskRowLabelHint
        }
        variant="body2"
        dangerouslySetInnerHTML={{
          __html: `<span>${clientEstateTaskInstance.labelHint}</span>`,
        }}
      />
      {clientEstateTaskInstance.deadlineDate && (
        <Typography>
          <Grid xs={12} alignItems="center" container>
            <Grid className={classes.deadlineText} xs={6} item>
              Deadline: {moment(clientEstateTaskInstance.deadlineDate).format('MMMM Do, YYYY')}
              <EditIcon
                className={classes.editDeadlineIcon}
                fontSize="small"
                onClick={(evt) => {
                  setCurrentEstateTaskInstance(clientEstateTaskInstance);
                  handleAddDeadlineClick(evt);
                }}
              />
              {!hasCalendarFeature && (
                <>
                  <br />
                  <span>*Upgrade to Add to Calendar</span>
                </>
              )}
            </Grid>
            <Grid xs={6} item>
              <AddToCalendarButton
                name={clientEstateTaskInstance.label || undefined}
                startDate={
                  clientEstateTaskInstance.deadlineDate
                    ? new Date(clientEstateTaskInstance.deadlineDate).toISOString().slice(0, 10)
                    : new Date().toISOString().slice(0, 10)
                }
                endDate={
                  clientEstateTaskInstance.deadlineDate
                    ? new Date(clientEstateTaskInstance.deadlineDate).toISOString().slice(0, 10)
                    : new Date().toISOString().slice(0, 10)
                }
                options={['Apple', 'Google', 'Outlook.com']}
                buttonStyle="text"
                listStyle="modal"
                size="0|0|0"
                hideBackground={true}
                disabled={!hasCalendarFeature}
              />
            </Grid>
          </Grid>
        </Typography>
      )}
    </Box>
  );
};
